'use client'

import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'
import { type Locale, locales, useLanguageStore } from '@/stores/language-store'
import { Globe } from 'lucide-react'
import { useTranslations } from 'next-intl'

const localeLabels: Record<Locale, string> = {
	en: 'English',
	ko: '한국어',
	zh: '中文',
}

const localeFlags: Record<Locale, string> = {
	en: '🇺🇸',
	ko: '🇰🇷',
	zh: '🇨🇳',
}

export function LanguagePicker() {
	const t = useTranslations('language')
	const { locale, setLocale } = useLanguageStore()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button
					type="button"
					className="flex h-8 cursor-pointer items-center gap-1.5 rounded-lg bg-brand-dark-light px-2 text-sm text-white transition-colors hover:bg-[#1a1d21]"
					aria-label={t('title')}
				>
					<Globe className="h-4 w-4" />
					<span>{localeFlags[locale]}</span>
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align="end"
				className="min-w-[140px] border-[#1a1d21] bg-brand-dark-light"
			>
				{locales.map(loc => (
					<DropdownMenuItem
						key={loc}
						onClick={() => setLocale(loc)}
						className={cn(
							'flex cursor-pointer items-center gap-2 text-white focus:bg-[#1a1d21] focus:text-white',
							locale === loc && 'bg-brand-blue/20'
						)}
					>
						<span>{localeFlags[loc]}</span>
						<span>{localeLabels[loc]}</span>
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
